<template>
  <!-- 区域页面的场景控制显示 三段代码结构一样，要改全要改-->
  <div v-if="judgeActivePage() === '区域' && viewType === 'region'" class="scene_view_stype" :class="$store.state.publicinfo.showRegionSenceText === '展开'
    ? 'scene_view_stype_default'
    : ''
    " ref="SenceFlex">
    <!-- ///拖动组件 -->
    <draggable v-model="DsceneList" @update="datadragEnd" v-bind="sortableOptions">
      <transition-group>
        <!-- 单个场景对象组件 -->
        <scene-item-view v-for="(value, index) in DsceneList" :key="value.sceneId"
          :OneScene="DsceneList[index]"></scene-item-view>

        <!-- ///////拖动组件 -->
      </transition-group>
    </draggable>
  </div>

  <!-- 常用页面的场景控制显示 三段代码结构一样，要改全要改-->
  <div v-else-if="judgeActivePage() === '常用' && viewType === 'home'" class="scene_view_stype" :class="$store.state.publicinfo.showHomeSenceText === '展开'
    ? 'scene_view_stype_default'
    : ''
    " ref="SenceFlex">
    <!-- ///拖动组件 -->
    <draggable v-model="DsceneList" @update="datadragEnd" v-bind="sortableOptions">
      <transition-group>
        <!-- 单个场景对象组件 -->
        <scene-item-view v-for="(value, index) in DsceneList" :key="value.sceneId"
          :OneScene="DsceneList[index]"></scene-item-view>

        <!-- ///////拖动组件 -->
      </transition-group>
    </draggable>
  </div>

  <!-- 常用页面的显示 添加常用场景的页面 显示使用 设备的也类似，只是设备不用计算title，所以不用区分使用的组件title 三段代码结构一样，要改全要改-->
  <div v-else-if="
    (judgeActivePage() === '修改常用设备' ||
      judgeActivePage() === '修改常用场景') &&
    viewType === 'configScene'
  " class="scene_view_stype">
    <!-- ///拖动组件 -->
    <draggable v-model="DsceneList" @update="datadragEnd" v-bind="sortableOptions">
      <transition-group>
        <!-- 单个场景对象组件 -->

        <scene-item-view v-for="(value, index) in DsceneList" :key="value.sceneId" :OneScene="DsceneList[index]"
          :viewType="viewType" @followOrderCompuder="followOrderCompuder"
          @followOrderCompuInc="followOrderCompuInc"></scene-item-view>
        <!-- ///////拖动组件 -->
      </transition-group>
    </draggable>
  </div>

  <!-- 常用页面全部展示的显示 -->
</template>

<script>
import {
  computerNotShowEleCount,
  judgeActivePage,
  changefollowOrder,
  changefollowOrderInc
} from 'common/tool'

import SceneItemView from 'components/content/contro-view/scene-view/scene-item-view'
import { format } from 'path'

import draggable from 'vuedraggable' /////拖动插件
import store from 'store/index' ///导入公共仓库

export default {
  name: 'sceneView',
  data() {
    return {
      DsceneList: this.sceneList, ////拖动的需要,这里只在第一次加载的时候会获取，但有可能获取的是空的，因为网络请求延时，为了排序需要，所有需要监听改变，重新赋值。
      Senceflex: {
        Width: '', //存放场景盒子的宽度，用来计算一行有几个元素
        eleWidth: 220, ///元素的宽度  已知
        EleTotalCount: 0, ///元素的总个数
        notShowEleCount: '',
        ifNotshow: ''
      },
      screenWidth: document.documentElement.clientWidth //屏幕宽度

      // objectMoveState: store.state.configinfo.objectMoveState /////是否允许拖拽排序是否允许拖拽排序
    }
  },
  props: {
    sceneList: Array,
    viewType: {
      type: String,
      default: 'moren'
    }
  },

  beforeCreate() {
    ///钩子函数：vue实例的挂载元素$el和数据对象data都为undefined，还未初始化。
  },
  components: {
    SceneItemView,
    draggable
  },
  computed: {
    sortableOptions() {
      return {
        animation: 500,
        sort: this.$store.state.configinfo.objectMoveState,
        disabled: !this.$store.state.configinfo.objectMoveState, // 禁止拖拽
        scroll: true,
      };
    },
  },
  methods: {
    judgeActivePage() {
      return judgeActivePage()
    },
    /////拖动插件需要
    getdata(evt) {
      console.log(evt.draggedContext.element.text)
    },
    datadragEnd(evt) {
      evt.preventDefault()
      console.log('拖动前的索引 :' + evt.oldIndex)
      console.log('拖动后的索引 :' + evt.newIndex)
      console.log(this.DsceneList)
    },
    followOrderCompuder(val) {
      console.log('点击了取消收藏')
      console.log(val)
      changefollowOrder(this.DsceneList, val)
    },
    followOrderCompuInc(val) {
      console.log('点击了添加收藏')
      console.log(val)
      changefollowOrderInc(this.DsceneList, val)
    }
  },
  watch: {
    screenWidth(val) {
      ///监听屏幕的宽度是否有变化  并通过一个定时器去抖动优化
      if (!this.timer) {
        this.screenWidth = val
        console.log('当前屏幕宽度' + val)
        this.timer = true
        let that = this
        setTimeout(function () {
          // console.log(that.screenWidth)  ///屏幕宽度
          // that.init()
          that.Senceflex.Width = that.$refs.SenceFlex.offsetWidth //得到场flex盒子的实际宽度
          that.timer = false
          //得到一行以外还有几个元素未显示
          that.Senceflex.EleTotalCount = that.sceneList.length ///初始化得到页面要显示的场景总个数
          console.log(
            '屏幕宽度改变时得到场景总个数' + that.Senceflex.EleTotalCount
          )
          console.log('单个场景的宽度' + that.Senceflex.eleWidth)
          console.log('场景总个数' + that.Senceflex.EleTotalCount)

          that.Senceflex.notShowEleCount = computerNotShowEleCount(
            that.Senceflex.Width,
            that.Senceflex.eleWidth,
            that.Senceflex.EleTotalCount
          )
          console.log('未显示场景的个数' + that.Senceflex.notShowEleCount)

          if (that.judgeActivePage() === '区域') {
            that.$store.dispatch(
              'asyUpdataRegionSenceCount',
              that.Senceflex.notShowEleCount
            ) //异步提交仓库
          } else if (that.judgeActivePage() === '常用') {
            that.$store.dispatch(
              'asyUpdataHomeSenceCount',
              that.Senceflex.notShowEleCount
            ) //异步提交仓库
          }
        }, 400)
      }
    },
    '$store.state.publicinfo.homeSceneCount': function (val) {
      console.log(this.viewType)
      if (this.viewType === 'home') {
        ////说明是正常的场景控制页面
        //监听仓库VUEX的数据变化  常用页面的场景的数组发生变化
        this.$nextTick(() => {
          console.log('常用页面场景总个数发生变化' + val)
          console.log(this.judgeActivePage())

          ///在这里也执行一遍的原因 是由于场景数组请求接口有一个延时，导致页面已经加载完了，场景的个数没有能得到最新的（解决展开和收起不正常显示的BUG）
          console.log(this.sceneList.length)
          console.log(this.sceneList)
          this.Senceflex.Width = this.$refs.SenceFlex.offsetWidth //这里在刚渲染成功的时候取出场景盒子的宽度，用来计算一行有几个元素
          this.Senceflex.EleTotalCount = this.sceneList.length ///初始化得到页面要显示的场景总个数
          console.log(this.Senceflex.Width + '屏幕宽度')
          console.log(this.Senceflex.EleTotalCount + '要显示的场景总个数')
          // console.log(this.Senceflex.notShowEleCount)
          this.Senceflex.notShowEleCount = computerNotShowEleCount(
            this.Senceflex.Width,
            this.Senceflex.eleWidth,
            this.Senceflex.EleTotalCount
          )
          console.log(this.Senceflex.notShowEleCount + '还未显示的场景的个数')
          this.$store.dispatch(
            'asyUpdataHomeSenceCount',
            this.Senceflex.notShowEleCount
          ) //异步提交仓库
        })
      }
    },
    '$store.state.publicinfo.regionSceneCount': function (val) {
      if (this.viewType === 'region') {
        ////说明是正常的场景控制页面
        //监听仓库VUEX的数据变化  常用页面的场景的数组发生变化
        this.$nextTick(() => {
          console.log('区域页面场景总个数发生变化' + val)
          console.log('scene-view被激活了')
          ///在这里也执行一遍的原因 是由于场景数组请求接口有一个延时，导致页面已经加载完了，场景的个数没有能得到最新的（解决展开和收起不正常显示的BUG）
          console.log(this.sceneList.length)
          this.Senceflex.Width = this.$refs.SenceFlex.offsetWidth //这里在刚渲染成功的时候取出场景盒子的宽度，用来计算一行有几个元素
          this.Senceflex.EleTotalCount = this.sceneList.length ///初始化得到页面要显示的场景总个数
          console.log(this.Senceflex.Width + '屏幕宽度')
          console.log(this.Senceflex.EleTotalCount + '要显示的场景总个数')
          // console.log(this.Senceflex.notShowEleCount)
          this.Senceflex.notShowEleCount = computerNotShowEleCount(
            this.Senceflex.Width,
            this.Senceflex.eleWidth,
            this.Senceflex.EleTotalCount
          )
          console.log(this.Senceflex.notShowEleCount + '还未显示的场景的个数')
          this.$store.dispatch(
            'asyUpdataRegionSenceCount',
            this.Senceflex.notShowEleCount
          ) //异步提交仓库
        })
      }
    },
    // 拖动功能需要
    sceneList: {
      handler(newValue, oldValue) {
        console.log('场景展示数据发生了改变')
        // 监听设备展示数据是否发生变化
        this.DsceneList = newValue ////重新赋值
        // console.log(oldValue)
      },
      deep: true //深度监听,监听数组的第二层数据变化
    },
    DsceneList: {
      handler(newValue, oldValue) {
        console.log('场景展示数据发生了改变1')
        // this.DsceneList = newValue ////重新赋值
        ///界面管理数据的同步，这样做可以做到全面数据的状态更新同步，这里可能会出现问题，造成页面数据更新错误
        let page = judgeActivePage()
        if (page === '区域') {
          this.$store.dispatch(
            'asyUpdataregionServeDatasceneList',
            this.DsceneList
          ) ///异步提交当前页面需要展示的控制数据
        } else if (page === '常用') {
          this.$store.dispatch(
            'asyUpdatahomeServeDatasceneList',
            this.DsceneList
          ) ///异步提交当前页面需要展示的控制数据
        }

        // 监听设备展示数据是否发生变化
        // this.DdeviceList = newValue ////重新赋值
        // console.log(oldValue)
      },
      deep: true //深度监听,监听数组的第二层数据变化
    }
  },
  created() {
    ///钩子函数: vue实例的数据对象data有了，$el还没有
    console.log('scene-view被创建了')
  },
  beforeMount() {
    ///钩子函数: vue实例的$el和data都初始化了，但还是虚拟的dom节点，具体的data.filter还未替换。
  },
  activated() {
    console.log('scene-view被激活了')
    ///在这里也执行一遍的原因 是由于该组件会被keep-live缓存，需要把mounted要执行的组件初始化放到这里一份
    console.log(this.viewType)

    if (this.viewType === 'home' || this.viewType === 'region') {
      ////说明是正常的场景控制页面
      this.$nextTick(() => {
        console.log(this.sceneList.length)
        //创建监听屏幕变化
        const that = this
        window.onresize = () => {
          return (() => {
            window.screenWidth = document.body.clientWidth
            that.screenWidth = window.screenWidth
          })()
        }
      })
    }
  },
  mounted() {
    // 拖动功能需要
    //为了防止火狐浏览器拖拽的时候以新标签打开，此代码真实有效
    document.body.ondrop = function (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    //vue实例挂载完成，data.filter成功渲染  一般数据请求放在这里
    // console.log("scene-view被渲染成功了");
    // this.$nextTick(() => {
    //   this.Senceflex.Width = this.$refs.SenceFlex.offsetWidth; //这里在刚渲染成功的时候取出场景盒子的宽度，用来计算一行有几个元素
    //   this.Senceflex.EleTotalCount = this.sceneList.length; ///初始化得到页面要显示的场景总个数
    //   this.Senceflex.notShowEleCount = computerNotShowEleCount(
    //     this.Senceflex.Width,
    //     this.Senceflex.eleWidth,
    //     this.Senceflex.EleTotalCount
    //   );
    //   if (this.judgeActivePage() === "区域") {
    //     this.$store.dispatch(
    //       "asyUpdataRegionSenceCount",
    //       this.Senceflex.notShowEleCount
    //     ); //异步提交仓库
    //   } else if (this.judgeActivePage() === "常用") {
    //     this.$store.dispatch(
    //       "asyUpdataHomeSenceCount",
    //       this.Senceflex.notShowEleCount
    //     ); //异步提交仓库
    //   }
    //   //创建监听屏幕变化
    //   const that = this;
    //   window.onresize = () => {
    //     return (() => {
    //       window.screenWidth = document.body.clientWidth;
    //       that.screenWidth = window.screenWidth;
    //     })();
    //   };
    // });
  },
  beforeDestroy() {
    ////组件销毁前调用
    console.log('scene-view被销毁前')
  },
  destroyed() {
    console.log('scene-view被销毁后')
  }
}
</script>

<style>
.scene_view_stype>div>span {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  /**属性定义了多根主轴线时  垂直的对齐方式。如果项目只有一根轴线，该属性不起作用。 */
  align-items: center;
}

/* 默认只显示一行 */
.scene_view_stype_default {
  height: 100px;
  overflow: hidden;
}
</style>
